"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const SVG_1 = __importDefault(require("./SVG"));
const Icon = (0, styled_components_1.default)(SVG_1.default) `
    path {
        fill: #54b948;
    }
`;
exports.default = () => (react_1.default.createElement(Icon, { viewBox: "0 0 16 16" },
    react_1.default.createElement("path", { d: "M12.9 13A7 7 0 009 1v2.1a5 5 0 012 8.9V8l-2 2v5h5l2-2h-3.1zM2 1L0 3h3.1A7 7 0 007 15v-2.1A5 5 0 015 4v4l2-2V1H2z" })));
//# sourceMappingURL=Refresh.js.map